import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=2bfdc0f2&scoped=true"
import script from "./privilege.vue?vue&type=script&lang=js"
export * from "./privilege.vue?vue&type=script&lang=js"
import style0 from "./privilege.vue?vue&type=style&index=0&id=2bfdc0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdc0f2",
  null
  
)

export default component.exports